import { Tabs } from "@mantine/core";

import { useGetDeviceType } from "_common/hooks/global";
import Icon                 from "_components/atoms/icon";
import SlideUpModal         from "_components/atoms/slideUpModal";
import Typography           from "_components/atoms/typography";
import CreatePoll           from "_components/molecules/createPoll";
import QuestionCard         from "_components/organisms/questionCard";
import useStyles            from "_styles/atoms/pollsModals";

const component = props => {

	const {
		polls,
		togglePolls,
		tab,
		handleChangeTab,
		createPoll,
		toggleCreatePoll,
		liveData,
		endedData,
		broadcastId,
		isStudioPage,
		isPopOutChat,
		pollsConfig,
		setTab,
		setPollsCount
	} = props;

	const showOverlay = polls || createPoll;
	const deviceType  = useGetDeviceType ();
	const isMobile    = deviceType === "mobile";

	const { classes } = useStyles ( { isMobile }, { name: "styles" } );

	const liveCount  = liveData?.length;
	const endedCount = endedData?.length;

	return (
		<>

			<Overlay
				createPoll       = { createPoll }
				polls            = { polls }
				showOverlay      = { showOverlay }
				toggleCreatePoll = { toggleCreatePoll }
				togglePolls      = { togglePolls }
			/>

			<SlideUpModal
				displayModal = { polls }
				from         = "polls"
			>
				<div className = { classes.pollsWrapper }>

					<div className = { classes.header }>

						<Typography
							className = { classes.headerText }
							title     = "Manage Polls"
						/>

						<Icon
							className = { classes.crossButton }
							name      = "cross"
							onClick   = { () => {
								togglePolls ();
								setTab ( "polls-0" );
							} }
						/>
					</div>

					<Tabs
						className = { classes.tabs }
						onChange  = { handleChangeTab }
						value     = { tab }
					>
						<Tabs.List>

							<Tabs.Tab
								className = { classes.tab }
								label     = { `Live (${ liveCount }/3)` }
								value     = "polls-0"
							>
								{`Live (${ liveCount }/3)`}

							</Tabs.Tab>

							<Tabs.Tab
								className = { classes.tab }
								label     = { `Ended (${ endedCount })` }
								value     = "polls-1"
							>
								{`Ended (${ endedCount })`}

							</Tabs.Tab>
						</Tabs.List>

						<Tabs.Panel
							className = { classes.tabPanel }
							value     = "polls-0"
						>
							<LiveContentTab
								broadcastId       = { broadcastId }
								disableCreatePoll = { liveCount >= 3 }
								isPopOutChat      = { isPopOutChat }
								isStudioPage      = { isStudioPage }
								liveData          = { liveData }
								setPollsCount     = { setPollsCount }
								toggleCreatePoll  = { toggleCreatePoll }
							/>
						</Tabs.Panel>

						<Tabs.Panel
							className = { classes.tabPanel }
							value     = "polls-1"
						>
							<EndedContentTab
								broadcastId  = { broadcastId }
								endedData    = { endedData }
								isPopOutChat = { isPopOutChat }
								isStudioPage = { isStudioPage }
							/>
						</Tabs.Panel>

					</Tabs>

				</div>

			</SlideUpModal>

			<SlideUpModal
				adjustZIndex = { createPoll }
				displayModal = { createPoll }
				from         = "create-poll"
			>

				<CreatePoll
					broadcastId      = { broadcastId }
					pollsConfig      = { pollsConfig }
					toggleCreatePoll = { toggleCreatePoll }
				/>

			</SlideUpModal>
		</>

	);
};

export default component;

const calcPercentage = data => {
	const { options } = data;
	let sum           = 0;

	options?.map ( opt => {
		sum += opt.votes;
	} );

	return sum;
};

const EmptyTabView = ( { styleProp, subHeading, text } ) => {
	const { classes } = useStyles ();

	return (
		<div className = { classes.emptyFeedWrapper }>
			<Icon
				name  = "emptyFeed"
				style = { styleProp }
			/>

			<Typography
				className = { classes.errorText }
				title     = { text }
			/>

			<Typography
				className = { classes.errorSubHeading }
				title     = { subHeading }
			/>
		</div>
	);
};

const LiveContentTab = ( { toggleCreatePoll, liveData, broadcastId, disableCreatePoll, isStudioPage, isPopOutChat, setPollsCount } ) => {

	const { classes } = useStyles ( { disableCreatePoll } );

	return (
		<div className = { classes.tabContainer }
			style         = { { justifyContent: liveData?.length ? "flex-start" : "space-between" } }
		>
			{
				!liveData?.length && (
					<EmptyTabView
						styleProp  = { { height: "140px" } }
						subHeading = { ( isStudioPage || isPopOutChat ) ? "Create a new Live poll for your viewers. It’s a fun way of interacting with your viewers." : "" }
						text       = "No Live Polls"
					/>
				)
			}

			{( isStudioPage || isPopOutChat ) && (
				<div
					className = { classes.createPollsButton }
					onClick   = { () => toggleCreatePoll ( disableCreatePoll ) }
				>
					+ Create Poll
				</div>
			)}

			{liveData.map ( data => {
				const totalVotes = calcPercentage ( data );

				return (
					data?.softDelete ? (
						<div className = { classes.deleteText }>
							<Typography
								title = "Poll Deleted"
							/>
						</div>
					) : (
						<QuestionCard
							key           = { data.id }
							broadcastId   = { broadcastId }
							isPopOutChat  = { isPopOutChat }
							isStudioPage  = { isStudioPage }
							pollData      = { data }
							setPollsCount = { setPollsCount }
							totalVotes    = { totalVotes }
						/>
					)
				);
			} )}
		</div>
	);
};

const EndedContentTab = ( { endedData, broadcastId, isStudioPage, isPopOutChat } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.tabContainer }
			style         = { { justifyContent: endedData?.length ? "flex-start" : "space-between" } }
		>
			{
				!endedData?.length && (
					<EmptyTabView
						styleProp  = { { height: "140px" } }
						subHeading = { ( isStudioPage || isPopOutChat ) ? "The ended polls will appear here" : "" }
						text       = "No Ended Polls"
					/>
				)
			}

			{endedData.map ( data => {
				const totalVotes = calcPercentage ( data );

				return (
					data?.softDelete ? (
						<div className = { classes.deleteText }>
							<Typography
								title = "Poll Deleted"
							/>
						</div>
					) : (
						<QuestionCard
							key          = { data.id }
							broadcastId  = { broadcastId }
							isPopOutChat = { isPopOutChat }
							isStudioPage = { isStudioPage }
							pollData     = { data }
							totalVotes   = { totalVotes }
						/>
					)
				);
			} )}
		</div>
	);
};

const Overlay = ( { showOverlay, togglePolls, toggleCreatePoll, polls, createPoll } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div
			className = { !showOverlay ? classes.overlay : classes.overlayShow }
			onClick   = { () => {
				if ( polls && !createPoll ) togglePolls ();
				if ( createPoll ) toggleCreatePoll ();
			} }
		/>
	);
};
